export function getdate(month,months) {
  window.scrollTo(0,0)
  if (month=="...current month") {
    let crdt = [(new Date()).getDate(), (new Date()).getMonth()+1]
    let date1 = (crdt[0] >=1 && crdt[0] <= 15) ? 'Early' : 'Late'
    let date2 = (months.find( ({ value }) => value == crdt[1]*2 )).desc.split(' ')[1]
    this.month={"value": (months.find( ({ desc }) => desc == date1 + ' ' +date2 )).value, "desc": date1 + ' ' +date2}
  }
}